var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstitutionsLoadMoreSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 882 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 882,
    height: 1,
    fill: "#F1F3F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 882,
    height: 47,
    transform: "translate(0 1)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 11,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#DDE3EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 20.5,
    width: 91,
    height: 8,
    rx: 4,
    fill: "#DDE3EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 20.5,
    width: 46,
    height: 8,
    rx: 4,
    fill: "#DDE3EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 699,
    y: 20.5,
    width: 47,
    height: 8,
    rx: 4,
    fill: "#DDE3EB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 20.5,
    width: 50,
    height: 8,
    rx: 4,
    fill: "#DDE3EB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 882,
    height: 1,
    transform: "translate(0 48)",
    fill: "#F7F8F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 882,
    height: 47,
    transform: "translate(0 49)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 59,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#F1F3F5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 68.5,
    width: 47,
    height: 8,
    rx: 4,
    fill: "#F1F3F5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 603,
    y: 68.5,
    width: 41,
    height: 8,
    rx: 4,
    fill: "#F1F3F5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 701,
    y: 68.5,
    width: 45,
    height: 8,
    rx: 4,
    fill: "#F1F3F5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 794,
    y: 68.5,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#F1F3F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionsLoadMoreSkeleton);
export default __webpack_public_path__ + "static/media/institutions-load-more-skeleton.1b99be05effb8d023752a54edbf3a8c9.svg";
export { ForwardRef as ReactComponent };